import Popup from 'src/components/Popup';

interface ConfirmPopupProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
}

const ConfirmPopup = ({ isOpen, onClose, title = 'Confirm', message = 'Are you sure?', confirmText = 'Confirm', cancelText = 'Cancel', onConfirm }: ConfirmPopupProps) => {
  return (
    <Popup isOpen={isOpen} onClose={onClose}>
      <h2 className="text-lg font-semibold">{title}</h2>
      <p className="text-sm text-gray-600 mb-6">{message}</p>
      <div className="flex gap-3">
        <button
          onClick={onClose}
          className="flex-1 px-4 py-2 bg-light-gray rounded-full hover:bg-gray-300 transition-colors"
        >
          {cancelText}
        </button>
        <button
          onClick={() => { onConfirm(); onClose(); }}
          className="flex-1 px-4 py-2 bg-secondary-bg text-white rounded-full transition-colors"
        >
          {confirmText}
        </button>
      </div>
    </Popup>
  );
};

export default ConfirmPopup;


